import { Flex } from "orcs-design-system";
import styled from "styled-components";

export const TabBar = styled(Flex)`
  border-bottom: 2px solid ${({ theme }) => theme.colors.greyLighter};
  gap: 0;
`;

export const Tab = styled.button`
  padding: 6px 16px;
  font-size: 13px;
  font-weight: ${({ $active }) => ($active ? 600 : 400)};
  color: ${({ $active, theme }) =>
    $active ? theme.colors.primary : theme.colors.greyDark};
  background: transparent;
  border: none;
  border-bottom: 2px solid
    ${({ $active, theme }) => ($active ? theme.colors.primary : "transparent")};
  margin-bottom: -2px;
  cursor: pointer;
`;
